import { Swiper } from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

import 'swiper/scss'; // Core
import 'swiper/scss/autoplay';
import 'swiper/scss/effect-fade';

import './style.scss';

/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable no-new */
function blockSetup() {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */

	const blockType = 'banner-image';
	const blockClass = `block--${ blockType }`;

	function initBlock( blockClass ) {
		if ( blockClass.querySelectorAll( '.swiper-slide' ).length > 1 ) {
			// eslint-disable-next-line no-undef
			new Swiper( blockClass.querySelector( '.swiper' ), {
				modules: [ Autoplay, EffectFade ],
				slidesPerView: 1,
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				autoplay: {
					delay: 2000,
					disableOnInteraction: false,
				},
				loop: true, // Make sure to loop the slides for continuous autoplay
			} );
		}
	}

	/**
	 * Initialize each block on page load (front end).
	 */
	document.addEventListener( 'DOMContentLoaded', () => {
		console.log( blockClass );
		document.querySelectorAll( `.${ blockClass }` ).forEach( ( block ) => {
			console.log( block );
			initBlock( block );
		} );
	} );

	/**
	 * Initialize dynamic block preview (editor).
	 */
	const initializeBlock = function ( $block ) {
		const block = $block[ 0 ].querySelector( `.${ blockClass }` );

		if ( block ) {
			initBlock( block );
		}
	};

	if ( window.acf ) {
		window.acf.addAction(
			`render_block_preview/type=${ blockType }`,
			initializeBlock
		);
	}
}
blockSetup();
